/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { blobTypeStream, download, href } from "../Constants/DownloadConstants";

export function constructCsvDownload(file: string, fileName: string): void {
  const blob = new Blob([file], { type: blobTypeStream });
  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");

  downloadLink.setAttribute(href, url);
  downloadLink.setAttribute(download, fileName);
  document.body.appendChild(downloadLink);

  downloadLink.click();
}
